import { Anchor, Text, Tooltip } from '@mantine/core';
import { useIsLgBreakpoint } from 'hooks';
import { useTranslation } from 'react-i18next';

import { EmailSentTooltipLabel } from 'shared/ui/EmailSentTooltipLabel';
import { TextLoader } from 'shared/ui/TextLoader';

type Props = {
  isLoading: boolean;
  resendCode: () => void;
  isSmsMethod: boolean;
};

export const LoginOTPResendCode = ({
  isLoading,
  resendCode,
  isSmsMethod,
}: Props) => {
  const { t } = useTranslation('user');

  const isLgBreakpoint = useIsLgBreakpoint();

  return isLoading ? (
    <TextLoader>
      {t(isSmsMethod ? 'sendingOtpCodeSms' : 'sendingOtpCode', { ns: 'user' })}
    </TextLoader>
  ) : (
    <Text
      size="sm"
      align="center"
      sx={theme => ({
        margin: theme.other.spacing(-1, 0, 1),
      })}
    >
      {isLgBreakpoint && !isSmsMethod ? (
        <Tooltip label={<EmailSentTooltipLabel />}>
          <Text span size="md">
            {t('codeNotArrive', { ns: 'user' })}
          </Text>
        </Tooltip>
      ) : (
        t('codeNotArrive', { ns: 'user' })
      )}{' '}
      <Anchor component="button" onClick={resendCode}>
        {t('sendAnother', { ns: 'user' })}
      </Anchor>
    </Text>
  );
};
